module.exports = __webpack_public_path__ + "static/img/dialog2.80dbead.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/activity4/dialog2.png
// module id = Owsd
// module chunks = 7